import { Container } from 'inversify';
import { ax, AxiosInstance, IAxiosId } from './axios';
import { InjectionKey, Plugin, inject } from 'vue';
import { IProfileService, IProfileServiceId, IConfigService, IConfigServiceId } from '@/services';
import { IOrderApi, IOrderApiId } from '@/features/OrderHistory/services/Interface/IOrderApi';
import { AppConfigService } from '@/services/AppConfigService';
import { ProfileService } from '@/services/ProfileService';
import { ITravelCardApi, ITravelCardApiId } from '@/features/TravelCards/services/Interface/ITravelCardApi';
import OrderApi from '@/features/OrderHistory/services/';
import TravelCardApi from '@/features/TravelCards/services/';
import { IProfileApi, IProfileApiId } from '@/features/Profile/services/Interface/IProfileApi';
import ProfileApi from '@/features/Profile/services';
import { IBookingApi, IBookingApiId } from '@/features/Bookings/services/Interface/IBookingApi';
import BookingApi from '@/features/Bookings/services/';

const __INVERSIFY_SYMBOL__ = Symbol.for('app-inversify-container');
const injectionKey: InjectionKey<Container> = __INVERSIFY_SYMBOL__;

export function createContainer(): Plugin {
    const container = new Container();

    container.bind<AxiosInstance>(IAxiosId).toConstantValue(ax);
    container.bind<IOrderApi>(IOrderApiId).to(OrderApi);
    container.bind<ITravelCardApi>(ITravelCardApiId).to(TravelCardApi);
    container.bind<IConfigService>(IConfigServiceId).to(AppConfigService);
    container.bind<IProfileService>(IProfileServiceId).to(ProfileService);
    container.bind<IProfileApi>(IProfileApiId).to(ProfileApi);
    container.bind<IBookingApi>(IBookingApiId).to(BookingApi);

    return {
        install(app) {
            app.provide(injectionKey, container);
        }
    };
}

export function useContainer() {
    const _container = inject(injectionKey);
    if (!_container) throw new Error('You must call createContainer() first');

    return _container;
}
